import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'credits-display',
  template: `
    <ng-container *ngIf="credits > 0">
      <span class="plugin-credits">{{ credits }}</span>
      <img
        *ngIf="showToken"
        src="./assets/images/evatoken.svg"
        class="eva-token"
      />
    </ng-container>
    <span *ngIf="credits === 0" class="plugin-credits free">{{ 'plugins.free' | translate }}</span>
  `,
  styles: [
    `
      .plugin-credits {
        font-weight: 600;
      }
      .green {
        color: #33a06e;
      }
      .eva-token {
        width: 17px;
        margin-bottom: 3px;
      }
      .free {
        text-transform: uppercase;
      }
    `
  ]
})
export class CreditsDisplayComponent implements OnInit {
  @Input() credits: number = -1;
  @Input() green: boolean = false;
  @Input() showToken: boolean = true;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/credits-display.component.ts